import styled from "styled-components";
import { palette } from "styled-theme";

export const NumberBall = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  width: 55px;
  background-color: #c0c0c0;
  border-radius: 100%;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  position: relative;
  z-index: 99;

  .check {
    height: 25px;
    display: none;
    path {
      fill: white;
    }
  }

  &.is-active {
    background-color: ${palette("color", 15)};
    color: #fff;

    .check {
      display: block;
    }
  }

  &.is-complete {
    .check {
      display: block;
    }

    &:before {
      content: "";
    }
  }
`;
